import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const InternalTransactionStepAccount = ({
  txnPayLoad,
  setTxnPayLoad,
  isInternalAccountPopupOpen,
  setIsInternalAccountPopupOpen,
  openOwner,
  setOpenOwner,
  isConfidential,
  setIsConfidential,
  removeAccount,
  setRemoveAccount,
  activeType,
  setActiveType,
  removePan,
  setRemovePan,
  removeIfsc,
  setRemoveIfsc,
  shouldShowAssociatedAccounts,
  handleOwnerSelection,
  handleAccountSelection,
}) => {
  return (
    <div className="w-width-full Qlg:px-padding-base px-padding-md py-padding-md max-w-tab-width-normal mx-auto">
      <CommonLayout>
        <SourceDestinationAccountDetail
          type="source"
          modalOpen={openOwner}
          setModalOpen={setOpenOwner}
          txnPayLoad={txnPayLoad}
          setTxnPayLoad={setTxnPayLoad}
          handleOnAccountSelection={handleOwnerSelection}
        />

        <div
          className={`lg:flex-1 lg:max-w-[var(--create-box-width)] w-width-full lg:w-auto ${!txnPayLoad?.ownerBankAccountNo ? "opacity-light-opacity pointer-events-none" : "opacity-base-opacity"}`}
        >
          <SourceDestinationAccountDetail
            type="destination"
            flow="internal"
            modalOpen={isInternalAccountPopupOpen}
            setModalOpen={setIsInternalAccountPopupOpen}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            shouldShowAssociatedAccounts={shouldShowAssociatedAccounts}
            handleOnAccountSelection={handleAccountSelection}
            activeType={activeType}
            setActiveType={setActiveType}
            setRemPan={setRemovePan}
            setRemAccount={setRemoveAccount}
            setRemIFSC={setRemoveIfsc}
            remIFSC={removeIfsc}
            remAccount={removeAccount}
            remPan={removePan}
          />
        </div>

        <ConfidentialCard
          icon={ICONS.CONFIDENTIAL_TRANSACTION}
          title={globalText?.CREATE_AS_CONFIDENTIAL}
          note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
          toggleState={isConfidential}
          onToggle={() => setIsConfidential(!isConfidential)}
        />
      </CommonLayout>
    </div>
  );
};

export default InternalTransactionStepAccount;
